import { render, staticRenderFns } from "./DocFaceLibraryResourceShow.vue?vue&type=template&id=24817402&scoped=true"
import script from "./DocFaceLibraryResourceShow.vue?vue&type=script&lang=js"
export * from "./DocFaceLibraryResourceShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24817402",
  null
  
)

export default component.exports